import React, { useEffect, useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal } from "antd";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import CloseIcon from "@mui/icons-material/Close";

import emailEditor from "../../../../common/EmailEditor";
import styles from "../../../SwmsMasters/SwmsMastersStyle.module.css";

const toEditorState = (html = "") => {
  if (!html) return EditorState.createEmpty();
  const parsed = htmlToDraft(`${html}`);
  return parsed && parsed.contentBlocks
    ? EditorState.createWithContent(ContentState.createFromBlockArray(parsed.contentBlocks))
    : EditorState.createEmpty();
};

const toHtml = (state) => state && state.getCurrentContent().hasText()
  ? draftToHtml(convertToRaw(state.getCurrentContent()))
  : "";

function ReadinessHeadingEditorModal({ headingLabel, initialValues, handleSubmit, pristine, change, onClose, onSave }) {
  const initialState = useMemo(() => toEditorState(initialValues && initialValues.heading_content), [initialValues]);
  const [editorState, setEditorState] = useState(initialState);

  useEffect(() => setEditorState(initialState), [initialState]);

  const handleEditorChange = (nextState) => {
    setEditorState(nextState);
    change("heading_content", toHtml(nextState));
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible
      onCancel={onClose}
      destroyOnClose
      maskClosable={false}
      width={900}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      getContainer={() => document.body}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();
          handleSubmit(() => onSave(toHtml(editorState)))(event);
        }}
      >
        <div className="v2-modal-container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className={styles.ModalHeading}>{`Edit ${headingLabel}`}</div>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Heading Content</div>
                <div className="swmsv2-custom-draft-editor">
                  <Field
                    name="heading_content"
                    component={emailEditor}
                    editorState={editorState}
                    onEditorStateChange={handleEditorChange}
                    otherProps={{ editorStyle: { padding: "0px 4px", minHeight: "180px" } }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 pt-3 text-right">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "end", columnGap: "10px" }}>
                  <button type="button" className={styles.OutlinedButton} onClick={onClose} style={{ padding: "0px 5px" }}>Cancel</button>
                  <button type="submit" className={styles.PrimaryButton} disabled={pristine}>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default reduxForm({
  form: "readiness_heading_editor_modal",
  destroyOnUnmount: true,
  enableReinitialize: true
})(ReadinessHeadingEditorModal);
